import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  API_ACCOUNT_MANAGEMENT,
  API_ACCOUNT_MANAGEMENT_SEARCH,
  API_AVAILABLE_ROLES,
  API_BLOCK_USER,
  API_ROLES_CREATE,
  API_ROLES_EDIT,
  API_ROLES_UPDATE,
  API_UN_BLOCK_USER,
  API_UPDATE_POSITIONS_BY_DEPARTMENT,
  API_UPDATE_SECTIONS_BY_DEPARTMENT,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../constants/constants";
import {
  GET_ACCOUNT_MANAGEMENT,
  GET_ACCOUNT_MANAGEMENT_ALL,
  GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR,
  GET_ACCOUNT_MANAGEMENT_CREATE_ERROR,
  GET_ACCOUNT_MANAGEMENT_EDIT_ERROR,
  GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR,
  GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR,
  GET_AVAILABLE_ROLES,
  UPDATE_SELECTS_DEPENDING_DEPARTMENT,
} from "../types";

export const updateSelectsDependingDepartment = (id) => {
  return async (dispatch) => {
    try {
      const [responsePosition, responseSection] = await Promise.all([
        fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_UPDATE_POSITIONS_BY_DEPARTMENT + id),
        fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_UPDATE_SECTIONS_BY_DEPARTMENT + id),
      ]);

      const dataPosition = await responsePosition.json();
      const dataSection = await responseSection.json();

      const dataPositionWithId = dataPosition.map((item) => ({
        ...item,
        value: item.posId,
        label: item.posName,
        id: String(item.posId),
        key: "userPosition",
      }));

      const dataSectionWithId = dataSection.map((item) => ({
        ...item,
        value: item.sctId,
        label: item.sctName,
        key: "section",
        id: item.sctId,
      }));

      const combinedData = {
        dataPositionWithId,
        dataSectionWithId,
      };

      dispatch({
        type: UPDATE_SELECTS_DEPENDING_DEPARTMENT,
        data: combinedData,
      });
    } catch (error) {
      console.error("Error updating selects:", error);
    }
  };
};

export const getAccountManagementsBySurname = (searchParams, page) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_ACCOUNT_MANAGEMENT_SEARCH + "?page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(searchParams),
      },
    );

    const data = await response.json();

    for (let item of data.content) {
      item.blockedText = item.isBlocked ? "Да" : "-";
    }

    dispatch({
      type: GET_ACCOUNT_MANAGEMENT_ALL,
      data: data,
    });
  };
};

export const createRole = (data) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ROLES_CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_CREATE_ERROR,
        data: { errorStatus: true, errorText: await response.text() },
      });
    } else {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_CREATE_ERROR,
        data: { errorStatus: false, errorText: "" },
      });
    }
  };
};

export const getAccountManagement = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ACCOUNT_MANAGEMENT + id);

    const data = await response.json();

    const newData = {
      ...data,
      userPosition: String(data.userPosition),
    };

    dispatch({
      type: GET_ACCOUNT_MANAGEMENT,
      data: newData,
    });
  };
};

export const editRole = (id, data) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ROLES_EDIT + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_EDIT_ERROR,
        data: { errorStatus: true, errorText: await response.text() },
      });
    } else {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_EDIT_ERROR,
        data: { errorStatus: false, errorText: "" },
      });
    }
  };
};

export const unBlockUser = (id, searchParams, selectedPage) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_UN_BLOCK_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });

    if (!response.ok) {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR,
        data: { errorStatus: true, errorText: await response.text() },
      });
    } else {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR,
        data: { errorStatus: false, errorText: "" },
      });
      dispatch(getAccountManagementsBySurname(searchParams, selectedPage));
    }
  };
};

export const blockUser = (id, inputValue, searchParams, selectedPage) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_BLOCK_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, blockReason: inputValue }),
    });

    if (!response.ok) {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR,
        data: { errorStatus: true, errorText: await response.text() },
      });
    } else {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR,
        data: { errorStatus: false, errorText: "" },
      });
      dispatch(getAccountManagementsBySurname(searchParams, selectedPage));
    }
  };
};

export const updatePasswordRole = (id, data) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_ROLES_UPDATE + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR,
        data: { errorStatus: true, errorText: await response.text() },
      });
    } else {
      dispatch({
        type: GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR,
        data: { errorStatus: false, errorText: "" },
      });
    }
  };
};

export const getAvailableRoles = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_AVAILABLE_ROLES + id, {
      method: "POST",
    });

    const data = await response.json();

    dispatch({
      type: GET_AVAILABLE_ROLES,
      data: data,
    });
  };
};
